var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-payment-type", {
                          attrs: {
                            model: _vm.model.payment_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.payment_type_id,
                            label: "Tipo de Pagamento*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "payment_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-work-time-category", {
                          attrs: {
                            model: _vm.model.work_time_category_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.work_time_category_id,
                            label: "Categoria Período",
                            dense: "",
                            clearable: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "work_time_category_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-payment-event", {
                          attrs: {
                            model: _vm.model.payment_event_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.payment_event_id,
                            label: "Evento de Pagamento*",
                            dense: "",
                            "auto-complete": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "payment_event_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-company", {
                          attrs: {
                            model: _vm.model.company_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.company_id,
                            label: "Empresa",
                            dense: "",
                            clearable: "",
                            "auto-complete": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "company_id", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-brand", {
                          attrs: {
                            model: _vm.model.brand_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.brand_id,
                            label: "Marca",
                            clearable: "",
                            "auto-complete": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "brand_id", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-teacher-titling", {
                          attrs: {
                            model: _vm.model.teacher_titling_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.teacher_titling_id,
                            label: "Titulação",
                            clearable: "",
                            "auto-complete": "",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "teacher_titling_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }